__turbopack_context__.v({
  "item_amount": "DefaultSummaryBox-module-scss-module__9THyLq__item_amount",
  "item_title": "DefaultSummaryBox-module-scss-module__9THyLq__item_title",
  "summary_item": "DefaultSummaryBox-module-scss-module__9THyLq__summary_item",
  "summary_text": "DefaultSummaryBox-module-scss-module__9THyLq__summary_text",
  "wrap": "DefaultSummaryBox-module-scss-module__9THyLq__wrap",
});
